import { extraErrorDataIntegration, type Integration, type Options } from "@sentry/core";
import { EXTRA_ERROR_DATA_DEPTH } from "@remi/sentry";

import { resolveIntegrations } from "../resolveIntegrations";

export function buildIntegrations(
  baseConfigIntegrations: Options["integrations"],
  userIntegrations: Options["integrations"],
) {
  return (defaults: Integration[]) => {
    const base = resolveIntegrations(baseConfigIntegrations, defaults);
    const user = resolveIntegrations(userIntegrations, base);
    const merged = [...base, ...user].filter(
      (integration) => integration.name !== "Prisma" && integration.name !== "ExtraErrorData",
    );
    // Appended last so it wins Sentry's last-write-wins dedupe over any user-supplied ExtraErrorData (depth 3).
    return [...merged, extraErrorDataIntegration({ depth: EXTRA_ERROR_DATA_DEPTH })];
  };
}
